module.exports = __webpack_public_path__ + "img/536.8c0089af.png";